import { Colors, Icon } from "@blueprintjs/core";
import styled from "styled-components";

export const Main = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  position: relative;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;

  background-color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.DARK_GRAY2 : Colors.WHITE};
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.1));
`;

export const Messages = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px;
`;

export const Footer = styled.div`
  position: relative;
  padding: 10px 15px;
  background-color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.DARK_GRAY2 : Colors.WHITE};
  border-top: 1px solid
    ${({ theme: { darkMode } }) =>
      darkMode ? "rgba(255, 255, 255, 0.08)" : "rgba(15, 23, 42, 0.08)"};
`;

export const Suggestions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
`;

export const WelcomeText = styled.div`
  font-size: 25px;
  line-height: 1.6;
  margin-bottom: 10px;
  color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.LIGHT_GRAY5 : Colors.DARK_GRAY5};
`;

export const SuggestionChip = styled.span`
  display: inline-flex;
  border: 1px solid
    ${({ theme: { darkMode } }) =>
      darkMode ? Colors.DARK_GRAY5 : Colors.LIGHT_GRAY2};
  background-color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.DARK_GRAY2 : Colors.LIGHT_GRAY5};
  color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.LIGHT_GRAY5 : Colors.DARK_GRAY5};
  padding: 10px 14px;
  border-radius: 999px;
  font-size: 0.95rem;
`;

export const CloseIcon = styled(Icon)`
  position: absolute;
  top: 22px;
  right: 22px;
  cursor: pointer;
  color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.WHITE : Colors.GRAY1};
`;
